import store from '../store'
import axios from 'axios'
import { Base64 } from 'js-base64'

import { Installation } from 'config'
class HTTP {
  constructor () {
    this.state = store.getState().siteReducer
    store.subscribe(() => {
      this.state = store.getState().siteReducer
    })
  }
  get (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    console.log({
      params: {...query, ts: Date.now()},
      url: Installation.api_base + endpoint,
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    })
    return axios.request({
      params: {...query, ts: Date.now()},
      url: Installation.api_base + endpoint,
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      return [null, res]
    }).catch(err => [err, err.response ? err.response.data : err])
  }
  delete (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'delete',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      return [null, res]
    }).catch(err => [err, err.response ? err.response.data : err])
  }
  ping (endpoint) {
    return axios.request({
      params: {ts: Date.now()},
      timeout: 4000,
      url: Installation.api_base + endpoint,
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(this.state.auth.username + ':' + this.state.auth.password)
      }
    }).then(res => {
      return [null, res]
    }).catch(err => [err])
  }
  post (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'post',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      return [null, res]
    }).catch(err => [err, err.response ? err.response.data : err])
  }
  put (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'put',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      return [null, res]
    }).catch(err => [err, err.response ? err.response.data : err])
  }
}
export default new HTTP()



// WEBPACK FOOTER //
// ./src/API/http.js